module.exports = __webpack_public_path__ + "img/pageSettings.5139f157.svg";